import React from 'react';
import { graphql, Link, useStaticQuery } from 'gatsby';
import PropTypes from 'prop-types';

import {
  Layout,
  SEO,
  TextWithImage,
  JustLanded,
  JustDropped,
  NewsletterSignup,
  GoogleMap,
} from '../components';

function AboutPage() {
  const { about } = useStaticQuery(graphql`
    {
      about: file(relativePath: { eq: "about.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 720) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);

  return (
    <Layout>
      <SEO title="About" />
      <div className="grid gap-6 pt-6">
        <MissionSection image={about} />
        <JustLanded />
        <JustDropped />
      </div>
      <NewsletterSignup />
      <GoogleMap />
    </Layout>
  );
}

function MissionSection({ image }) {
  return (
    <TextWithImage image={image.childImageSharp.fluid}>
      <div className="prose-lg text-dark-pink">
        <h2 className="font-medium uppercase">Our Mission</h2>
        <p>
          Moda Latina is a new boutique that strives to bring style and
          sophistication to any outfit.
        </p>
        <p>
          We achieve this by importing the best quality clothing from Colombia
          and the most comfortable shoes from Costa Rica.
        </p>
      </div>
      <div className="mt-8">
        {/* TODO: Link CTA */}
        <Link to="/" className="uppercase button button-inverted">
          Start Creating Your Style
        </Link>
      </div>
    </TextWithImage>
  );
}

MissionSection.propTypes = {
  image: PropTypes.object.isRequired,
};

export default AboutPage;
